import React, { Component } from "react";
import AddIcon from "@material-ui/icons/Add";
import {
    Button, DialogActions, MenuItem, MenuList, Popover,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import PaperComponent from "./PaperComponent";
import DialogTitleComponent from "./DialogTitleComponent";
import DialogContent from "@material-ui/core/DialogContent";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import TablePagination from "@material-ui/core/TablePagination";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import ButtonComponent from "./ButtonComponent";

class EmailTemplateTable extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            openActionMenu: false,
            popoverElement: null,
            page: 0,
            rowsPerPage: 10,
            hello: '',
            templateList: {},
        }
    }
    componentDidMount() {
        this.props.fetchEmailTemplate();
    }

    render() {
        const fullHtmlString = "<html lang= \"en \"> <head> <meta name= \"viewport \" content= \"width=device-width, initial-scale=1, shrink-to-fit=no \"> <meta http-equiv= \"Content-Type \" content= \"text/html; charset=UTF-8 \"> <title>Everfund | Link share</title> <link rel= \"icon \" sizes= \"24x24 \" type= \"image/png \" href= \"https://everfund.brilltech.com/assets/images/everfund.png \"> <link href= \"https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap \" rel= \"stylesheet \"> <style> @media only screen and (max-width: 580px) { table[class= \"body \"] p, table[class= \"body \"] ul, table[class= \"body \"] ol, table[class= \"body \"] td, table[class= \"body \"] span, table[class= \"body \"] a { font-size: 12px !important; } table[class= \"body \"] .wrapper, table[class= \"body \"] .article { padding: 10px !important; } table[class= \"body \"] .content { padding: 0 !important; } table[class= \"body \"] .container { padding: 0 !important; width: 100% !important; } table[class= \"body \"] .main { border-left-width: 0 !important; border-radius: 0 !important; border-right-width: 0 !important; } .contributer_content { display: block; } } </style> </head> <body style= \"color: #333333; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; background-color: white; \"> <table border= \"0 \" cellpadding= \"0 \" cellspacing= \"0 \" class= \"body \" style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; height: 100vh; margin: 0; border-spacing: 0px; \" width= \"100% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"></td> <td class= \"container \" style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; display: block; max-width: 100%; padding: 10px; width: 100%; height: 100vh; margin: 0 auto; \" width= \"100% \" valign= \"top \"> <div class= \"content \" style= \"box-sizing: border-box; display: block; margin: 0 auto; max-width: 100%; \"> <table class= \"main \" style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background: #ffffff; border-radius: 3px; width: 100%; \" width= \"100% \"> <!-- START MAIN CONTENT AREA --> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; padding-right: 20px; \" valign= \"top \"> <!-- AnyDone header logo --> <table width= \"100% \" style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; border-spacing: 0; margin: 0; border-bottom: 1.5px solid #D2D2D2; min-width: 100%; \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; padding-top: 0px; padding-left: 0px; \" valign= \"top \"> <img src= \"https://everfund.brilltech.com/assets/images/everfund.png \" alt= \"logo \" width= \"200px \" style= \"border: none; -ms-interpolation-mode: bicubic; max-width: 100%; \"> <p style= \"font-family: Roboto; font-style: normal; font-weight: bold; font-size: 22px; margin: 0px; color: #333333; \"> </p> </td> </tr> </table> <!-- <hr class= \"line \" /> --> <br> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 80%; \" width= \"80% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"> <p style= \"font-family: Roboto; font-style: normal; font-size: 12px; margin: 10px 0 0 0; color: #333333; \"> Everfund has requested you to fillup the action form. </p> </td> </tr> </table> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; margin-top: 10px; \" width= \"100% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"> <a class= \"button \" style= \"background: #8bc83f; text-decoration: none; font-family: Roboto; padding: 5px 20px; border-radius: 3px; height: 34px; width: 134px; color: white; \" href= \"# \">Click here</a> </td> </tr> </table> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; \" width= \"100% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"> <p style= \"font-family: Roboto; font-style: normal; font-size: 12px; margin: 12px 0 0 0; color: #333333; \"> Or paste this link into your browser: </p> <a class= \"atag \" href= \"# \" style= \"color: #8bc83f; text-decoration: none; \"> {{url}} </a> </td> </tr> </table> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; margin-top: 10px; \" width= \"100% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"> <p style= \"font-family: Roboto; font-style: normal; font-size: 12px; margin: 0; color: #333333; \">Thank you,</p> <p style= \"font-family: Roboto; font-style: normal; font-size: 12px; margin: 0; color: #333333; \">Everfund Team.</p> </td> </tr> </table> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; margin-top: 13px; \" width= \"100% \"> <tr> <td style= \"font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; vertical-align: top; \" valign= \"top \"> <p style= \"font-family: Roboto; font-style: normal; font-size: 12px; margin: 0; color: #333333; \">© 2021 Everfund. All rights reserved</p> </td> </tr> </table> </td> </tr> <table style= \"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; \" width= \"100% \"> <!-- END CENTERED WHITE CONTAINER --> </table> </table> </div> </td> </tr> </table> </body> </html>";
        const demoStringReplace = fullHtmlString.replace(/\"/g, '"');

        function tidyHtml(html) {
            let htmlPart = html.trim().replace(/>[^<]+</gm, function ($1) {
                return '>' + $1.substr(1, $1.length - 2).trim() + '<';
            }).replace(/>\s+</gm, '><');
            var containerElement = document.createElement('html');
            containerElement.innerHTML = htmlPart;
            let result = containerElement.outerHTML;
            let findLevel = function (child, parent) {
                let level = 0;
                while (child != parent) {
                    child = child.parentNode;
                    level++;
                }
                return level;
            }
            Array.prototype.slice.call(containerElement.getElementsByTagName('*')).forEach(function (element) {
                var tabs = new Array(findLevel(element, containerElement) - 1).join('	'),
                    tabs2 = (element.parentNode.lastChild == element) ? ('\n' + tabs.substring(0, tabs.length - 1)) : '',
                    containerElement = document.createElement('div');
                containerElement.appendChild(element.cloneNode(true));
                result = result.replace(containerElement.innerHTML, '\n' + tabs + containerElement.innerHTML + tabs2);
            });
            return result;
        }

        const handleChangePage = (event, newPage) => {
            this.setState({
                page: newPage,
            });
            if(this.tableRef.current) {this.tableRef.current.scrollIntoView()}
        };
        const handleChangeRowsPerPage = event => {
            this.setState({
                rowsPerPage: parseInt(event.target.value, 10),
                page: 0
            });
            if(this.tableRef.current) {this.tableRef.current.scrollIntoView()}
        };

        const emailTemplatesData = this.props.emailTemplatesData;
        const htmlPart = this.props.htmlPart;
        const emailTemplateList = this.props.emailTemplateList;

        const value = emailTemplatesData.templateName !== '' &&
            emailTemplatesData.htmlPart !== '' && emailTemplatesData.subjectPart !== ''
            && emailTemplatesData.textPart !== '';
        const loading = this.props.loading;

        return(
            <React.Fragment>
                <div>
                    <div className={"d-flex flex-row-reverse div-flex"}>
                        <div>
                            <button
                                className="addButton"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.props.handleOpenToAddEmailTemplateModal()
                                }}>
                                <AddIcon/> Add Email Template
                            </button>
                        </div>
                    </div>
                    <div className={"row"} style={style.card}>
                        <TableContainer className="fixed-table-header-second">
                            <Table size="small" stickyHeader aria-label="sticky table" ref={this.tableRef}>
                                <TableHead style={{padding: "1rem"}}>
                                    <TableRow>
                                        <TableCell className="first-tableHeader" style={{width: "410px"}}>
                                            Template Name
                                        </TableCell>
                                        <TableCell className="tableHeader" style={{width: "410px"}}>
                                            Subject
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {emailTemplateList && emailTemplateList.slice(
                                    this.state.page * this.state.rowsPerPage,
                                    this.state.page * this.state.rowsPerPage +
                                    this.state.rowsPerPage
                                ).map(list => (
                                <TableBody>
                                    <TableRow >
                                        <TableCell className="first-tableBody">
                                            {list && list.templateName}
                                        </TableCell>
                                        <TableCell className="tableBody">
                                            {list && list.subjectPart}
                                        </TableCell>
                                        <TableCell className="tableBody" style={{width: "290px"}}>
                                            <MoreHorizIcon
                                                id="Popover1"
                                                style={{cursor: 'pointer'}}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.props.setEmailTemplateToEdit(list)
                                                    this.setState({
                                                        popoverElement: e.currentTarget,
                                                        openActionMenu: true,
                                                        templateList: list,
                                                    })
                                                }}
                                            />
                                            <Popover
                                                open={this.state.openActionMenu}
                                                anchorEl={this.state.popoverElement}
                                                onClose={(e) => {
                                                    e.preventDefault();
                                                    this.setState({openActionMenu: false})
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                style={{boxShadow: 'none'}}
                                            >
                                                <MenuList id="popover-list" style={{
                                                    color: '#4d4d4d',
                                                    padding: '1rem !important',
                                                    cursor: 'pointer'
                                                }}>
                                                    <MenuItem
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.props.handleOpenToEditEmailTemplateModal();
                                                            this.setState({openActionMenu: false,}
                                                            );
                                                        }}>
                                                        <EditOutlinedIcon style={{paddingBottom: 0}}/> Edit
                                                    </MenuItem>
                                                    <MenuItem
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.props.handleOpenToDeleteEmailTemplateModal();
                                                            this.setState({openActionMenu: false,}
                                                            );
                                                        }}>
                                                        <DeleteOutlinedIcon style={{paddingBottom: 0}}/> Delete
                                                    </MenuItem>
                                                </MenuList>
                                            </Popover>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>))}
                            </Table>
                            </TableContainer>
                            {emailTemplateList && emailTemplateList.length > 0 ? (
                                <div style={{justifyContent: "flex-start", width: "100%", borderTop: "0.1px solid rgba(224, 224, 224, 1)"}}>
                                    <TablePagination
                                        labelRowsPerPage={false}
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={
                                            emailTemplateList.length > 0
                                                ? emailTemplateList.length
                                                : 100
                                        }
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </div>
                            ) : (
                                <div style={{     
                                    display: "flex", 
                                    width: "100%",
                                    justifyContent:"center"
                                    }}>
                                    <h3
                                        style={{
                                            textAlign: "center",
                                            fontSize: "14px",
                                            padding: "1rem",
                                            color: "#606060"
                                        }}
                                    >
                                        {" "}
                                        No data to show
                                    </h3>
                                </div>
                            )}
                        {/* </TableContainer> */}
                    </div>
                </div>
                {/*add email templates*/}
                <Dialog
                    open={this.props.openModalToAddEmailTemplate}
                    onClose={()=>{
                        this.setState({
                            templateList: {},
                        })
                        this.props.handleCloseToAddEmailTemplateModal()
                    }}
                    PaperComponent={PaperComponent}
                    aria-labelledby="#draggable-dialog-title"
                    maxWidth="xl"
                >
                    <div>
                        <DialogTitleComponent
                            id="draggable-dialog-title"
                            onClose={()=>{
                                this.setState({
                                    templateList: {},
                                })
                                this.props.handleCloseToAddEmailTemplateModal()
                            }}
                        >
                           Add Email Template
                        </DialogTitleComponent>
                        <DialogContent
                            dividers
                            style={{
                               paddingTop: "5px",
                               borderBottom: "none",
                               width: "790px",
                               maxHeight: "790px"
                            }}
                            className="dialogContentForForms"
                        >
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="label">Template Name
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <input
                                        type='text'
                                        id="holiday"
                                        className="input"
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeEmailTemplateData("templateName",e.target.value)
                                        }}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <label className="label">Subject
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <input
                                        type='text'
                                        id="holiday"
                                        className="input"
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeEmailTemplateData("subjectPart",e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <label className="label">
                                        HTML<span style={{color: "red"}}> *</span>
                                        {
                                            htmlPart !== '' ?
                                                <span className="previewStyle" onClick={()=>{
                                                    this.props.handleOpenPreviewModal()
                                                }}>
                                            View Preview
                                        </span>: null
                                        }
                                    </label>
                                    <textarea
                                        className="textAreaDiv"
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeHtmlPart(e.target.value)
                                            this.props.handleChangeEmailTemplateData("htmlPart",
                                                (e.target.value).toString()
                                                    .replace(/(\r\n|\n|\r)/gm, '')
                                                    .replace(/>\s+/g, '>')
                                                    // .replace(/"/g, ' \\"')
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <label className="label">Text Part
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <textarea
                                        type='text'
                                        style={{minHeight: "70px"}}
                                        className="textAreaDiv"
                                        // value={emailTemplatesData.textPart}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeEmailTemplateData("textPart",e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div>
                                {/*<span>{emailTemplatesData.htmlPart}</span>*/}
                            </div>
                        </DialogContent>
                        <DialogActions style={{padding: "10px 28px 10px 0px"}}>
                            <ButtonComponent
                                loading={loading}
                                buttonName="Add"
                                value={value}
                                onClick={()=>{
                                    this.props.addEmailTemplate(emailTemplatesData)
                                }}
                         />
                        </DialogActions>
                    </div>
                </Dialog>

                {/*update email templates*/}
                <Dialog
                    open={this.props.openModalToUpdateEmailTemplate}
                    onClose={this.props.handleCloseToEditEmailTemplateModal}
                    PaperComponent={PaperComponent}
                    aria-labelledby="#draggable-dialog-title"
                    maxWidth="xl"
                >
                    {/*<pre>{docParse.firstChild}</pre>*/}
                    <div>
                        <DialogTitleComponent
                            id="draggable-dialog-title"
                            onClose={this.props.handleCloseToEditEmailTemplateModal}
                        >
                            Update Email Template
                        </DialogTitleComponent>
                        <DialogContent
                            dividers
                            style={{
                                paddingTop: "5px",
                                borderBottom: "none",
                                width: "790px",
                                maxHeight: "790px"
                            }}
                            className="dialogContentForForms"
                        >
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="label">Template Name
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <input
                                        type='text'
                                        disabled
                                        className="input"
                                        value={emailTemplatesData.templateName}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <label className="label">Subject
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <input
                                        type='text'
                                        id="holiday"
                                        value={emailTemplatesData.subjectPart}
                                        className="input"
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeEmailTemplateData("subjectPart",e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <label className="label">
                                        HTML<span style={{color: "red"}}> *</span>
                                            <span className="previewStyle" onClick={()=>{
                                                    this.props.handleOpenPreviewModal()
                                                }}>
                                            View Preview
                                        </span>
                                    </label>
                                    <textarea
                                        className="textAreaDiv"
                                        autoComplete='off'
                                        value={emailTemplatesData.htmlPart ? tidyHtml(emailTemplatesData.htmlPart) : ''}
                                        onChange={(e) => {
                                            this.props.handleChangeHtmlPart(e.target.value)
                                            this.props.handleChangeEmailTemplateData("htmlPart",
                                                (e.target.value).toString()
                                                    .replace(/(\r\n|\n|\r)/gm, '')
                                                    .replace(/>\s+/g, '>'));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <label className="label">Text Part
                                        <span style={{color: "red"}}> *</span>
                                    </label>
                                    <textarea
                                        type='text'
                                        style={{minHeight: "70px"}}
                                        className="textAreaDiv"
                                        value={emailTemplatesData.textPart}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            this.props.handleChangeEmailTemplateData("textPart",e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions style={{padding: "10px 28px 10px 0px"}}>
                            <ButtonComponent
                                loading={loading}
                                buttonName="Update"
                                value={value}
                                onClick={()=>{

                                    this.props.updateEmailTemplate(emailTemplatesData)
                                }}
                           />
                        </DialogActions>
                    </div>
                </Dialog>

                {/*preview email templates*/}
                <Dialog
                    open={this.props.openPreviewModal}
                    onClose={this.props.handleClosePreviewModal}
                    PaperComponent={PaperComponent}
                    aria-labelledby="#draggable-dialog-title"
                    maxWidth="xl"
                >
                    <div>
                        <DialogTitleComponent
                            id="draggable-dialog-title"
                            onClose={this.props.handleClosePreviewModal}
                        >
                            Template Preview
                        </DialogTitleComponent>
                        <DialogContent className="dialogContentForViewPreview">
                            <iframe
                                scrolling="no"
                                className="iframeForTemplate"
                                srcDoc={htmlPart}/>
                        </DialogContent>
                    </div>
                </Dialog>

                {/*DELETE*/}
                <Dialog
                    open={this.props.openModalToDeleteEmailTemplate}
                    onClose={this.props.handleCloseToDeleteEmailTemplateModal}
                    PaperComponent={PaperComponent}
                    aria-labelledby="#draggable-dialog-title"
                    maxWidth="xl"
                >
                    <DialogTitle id="draggable-dialog-title"  style={{cursor: "move"}}>
                        <h3 style={{color: '#8BC83F', padding: '0.8rem', textAlign: 'center'}}>
                            Confirmation</h3>
                    </DialogTitle>
                    <DialogContent
                        style={{
                            background: 'white',
                            textAlign: 'center',
                            width: '450px'
                        }}>
                        <DialogContentText>
                            Do you want to delete this email template?

                            <span className="row" style={{
                                paddingLeft: '10px',
                                paddingRight: "10px",
                                paddingBottom: '1rem',
                                paddingTop: '1.6rem'
                            }}>
                                <span className={"col-6"}>
                                    <Button autoFocus
                                            onClick={this.props.handleCloseToDeleteEmailTemplateModal}
                                            className="cancelButton">
                                        cancel
                                    </Button>
                                </span>

                                <span className={"col-6"}>
                                    <Button onClick={(e) => {
                                        this.props.handleCloseToDeleteEmailTemplateModal()
                                        this.props.deleteEmailTemplate(this.state.templateList && this.state.templateList.emailTemplateId)
                                        e.preventDefault();
                                    }} className="addUserButton">
                                        ok
                                    </Button>
                                </span>
                            </span>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    };
};
const style = {
    card: {
        background: "#ffffff",
        border: "1px solid rgb(224, 224, 224)",
        boxShadow:
            "rgba(0, 0, 0, 0) 0px 0px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 4px 0px",
        marginRight: 0,
        marginLeft: 0,
        marginBottom: "1rem",
    },
}

export default EmailTemplateTable;
